import { setupStoreBackend } from "@/toremove/setup";
//import router from '@/pages/app/router/user';
import Empty from "@/toremove/components/Empty.vue";

var baseStore = setupStoreBackend("user", "Userv2");
var state = {
    userEndpoint: "/user/",
    userEndpoints: {
        // User
        user: "/user/",
        emailcheck: "/user/check/email/",
        phonecheck: "/user/check/phone/",
    },
    keep_url: "/app/",
    // User
    userUniqueServerSided: true,
    userUseApiGroup: false,

    // to remove
    contextmenu: {
    //    id: 'context-menu',
        isopen: false,
        x: '',
        y: '',
        contain: Empty,
        props: {},
    },
    tooltip: {
        isopen: false,
        data: '',
        yOffset: 25,
        xOffset: 0,
    },
};
var getters = {
    isAuthenticated: state => state.accessToken,
    userApiUrlDetail: (state, getters) => () => {
        return getters.userApiUrlNamed("user") + "profile/";
    },
    userApiUrlList: (state, getters) => () => {
        return getters.userApiUrlNamed("user") + "profile/";
    },
    profile: (state) => { return state.userCurrent; },
    cssTheme: (state) => { return state.userCurrent.style; },
};
var actions = {
    async userLogout({ commit }){
        commit('LOGOUT');
        document.location.href = '/app/';
    },
    // User
    userKeepUrl({ commit }, url) {
        commit('KEEP_URL', url);
    },

    // to remove

    // ContextMenu
    openContextMenu({ commit }, payload){
        if('contain' in payload)
            commit('OPEN_CONTEXTMENU', payload);
    },
    closeContextMenu({ commit }) {
        commit('CLOSE_CONTEXTMENU');
    },


    // Tooltip
    openTooltip({ commit, state }, payload){
        if (state.tooltip.data == payload.data) {
            return ;
        }
        commit('CLOSE_TOOLTIP');
        commit('OPEN_TOOLTIP', payload);
    },
    closeTooltip({ commit, state }) {
        if (state.tooltip.isopen)
            commit('CLOSE_TOOLTIP');
    },
};

var mutations = {
    // User
    ['KEEP_URL'](state, url){
        state.keep_url = url;
    },
    // Tooltip
    ['OPEN_TOOLTIP'](state, payload){
        state.tooltip.isopen = true;
        state.tooltip.data = payload.data;
        const rect = payload.evt.target.getBoundingClientRect();
        state.tooltip.x = rect.right - ((rect.right - rect.left) / 2);
        state.tooltip.y = rect.top;
        if (payload.yOffset != undefined)
        {
            state.tooltip.y += payload.yOffset;
        }
        if (payload.xOffset != undefined)
        {
            state.tooltip.x += payload.xOffset;
        }
        // state.tooltip.yOffset = payload.yOffset ? payload.yOffset : 0;
        // state.tooltip.xOffset = payload.xOffset ? payload.xOffset : 0;
    },
    ['CLOSE_TOOLTIP'](state){
        state.tooltip =  {
            isopen: false,
            x: '',
            y: '',
            data: '',
            yOffset: 25,
            xOffset: 0,
        }
    },

};

import autoStore from "@/autolib/store.js";
export default autoStore("user", "Userv2", {
    namespaced: true,
    state: Object.assign(baseStore.state, state),
    getters: Object.assign(baseStore.getters, getters),
    actions: Object.assign(baseStore.actions, actions),
    mutations: Object.assign(baseStore.mutations, mutations),
}, {endpoint: "/user/", isPaginate: true});

